export enum SupportedLinks {
  'EN' = 'EN',
  'GLOBAL' = 'EN',
  'CN' = 'CN',
}
